/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FeatureFlagBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return FeatureFlagBase.fixupPrototype; }

    static newInstance(model: Partial<FeatureFlagBase>): FeatureFlagBase {
        let obj = Object.assign(new FeatureFlagBase(), model);
        FeatureFlagBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FeatureFlagBase>): FeatureFlagBase {
        if (!model) return null;
        return FeatureFlagBase.newInstance(<FeatureFlagBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FeatureFlagBase) {
        if (!obj) return;

        models.FeatureFlagBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FeatureFlagBase): boolean {
        switch (obj.__type)
        {
            case "FeatureFlag":
                Object.setPrototypeOf(obj, models.FeatureFlag.prototype);
                break;
            case "ReleaseFlag":
                Object.setPrototypeOf(obj, models.ReleaseFlag.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof FeatureFlagBase)[] {
        return [
            models.FeatureFlag,
            models.ReleaseFlag,
        ];
    }

    fixupFields() {
    }

    /**
     * The main category of the feature flag
     */
    category: models.FeatureFlagCategory;

    /**
     * Name of the feature flag
     */
    flag_name: string;

    /**
     * Description of the feature flag
     */
    description: string;

    /**
     * Whether the feature flag is enabled or not
     */
    enabled: boolean;

    /**
     * The feature flag's enabled by default or not
     */
    default: boolean;

}
